module.exports = __webpack_public_path__ + "img/wutupian.85f007a6.jpg";